import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'

import ExpertGuidance from './components/ExpertGuidance'

import StartWithStrategy from './components/StartWithStrategy'

import SpeedTimeToValue from './components/SpeedTimeToValue'

import UnlockYourFullPotential from './components/UnlockYourFullPotential'

import Video from './components/Video'

import Testimonials from './components/Testimonials'

import DatasheetsToDownload from './components/DatasheetsToDownload'

import AdditionalResources from './components/AdditionalResources'

import TimeToValue from './components/TimeToValue'
import MaturityModel from './components/MaturityModel/MaturityModel'

import FeatureBoxes from './components/FeatureBoxes'

import ogImagePng from './assets/OgServices.png'

const ServicesView = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Professional Services | Twilio Segment"
        pageDescription="Accelerate your time to value with Segment advisory services, resident architects, and jumpstart programs"
        pageOG={ogImagePng}
      >
        <Navigation />
        <Hero />
        <Main>
          <Video />
          <ExpertGuidance />
          <GrayBackground>
            <StartWithStrategy />
          </GrayBackground>
          <SpeedTimeToValue />
          <MaturityModel />
          <GrayBackground>
            <UnlockYourFullPotential />
            <Testimonials />
            <FeatureBoxes />
          </GrayBackground>
          <DatasheetsToDownload />
          <GrayBackground>
            <AdditionalResources />
            <TimeToValue />
          </GrayBackground>
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  /* Give a main content a background color, so sections don't flash from white background */
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

const GrayBackground = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export default ServicesView
